/**
 *
 * LOGIN
 *
 */

import Spinner from '@/components/Spinner.vue';
import Footer from '@/components/FooterPzId.vue';
import { LOGIN_PAGE } from '@/constants/routes';

import { AfterLoginMixin } from '@/scripts/Login/Login.mixin';
import { LoginPhoneMixin } from './LoginPhone.mixin';

export default {
  name: 'LoginPhone',

  mixins: [LoginPhoneMixin, AfterLoginMixin],

  components: {
    Footer,
    Spinner,
  },

  methods: {
    async backToLogin() {
      await this.ma_logout();
      this.$router.push(LOGIN_PAGE + this._makeUrlAddParamsAndHash());
    },

    afterLoginPhone() {
      this.goToNextPage();
    },
  },

  created() {
    this._loginPhoneCreated();
  },
};
